module.exports = __webpack_public_path__ + "static/img/Aurora.Andruska.ab1baf3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Aurora.Andruska.jpg
// module id = WAWP
// module chunks = 0